export enum FilterFormType {
  COURSE = 0,
  SECONDARY = 1,
  HIGHER = 2,
}

export enum IntakeType {
  OUTDATED = -1,
  SPRING = 1,
  SUMMER = 2,
  FALL = 3,
}

export const INTAKES = [
  {
    id: IntakeType.SPRING,
    name: "Spring",
  },
  {
    id: IntakeType.SUMMER,
    name: "Summer",
  },
  {
    id: IntakeType.FALL,
    name: "Fall",
  },
  {
    id: IntakeType.OUTDATED,
    name: "Outdated",
  },
];

export const INTAKES_MAP = {
  [IntakeType.SPRING]: "Spring",
  [IntakeType.SUMMER]: "Summer",
  [IntakeType.FALL]: "Fall",
  [IntakeType.OUTDATED]: "Outdated",
};

export enum ProgramType {
  ONLINE = "1",
  ON_CAMPUS = "2",
}

export enum ProgramTypeName {
  ONLINE = "Online",
  ON_CAMPUS = "On Campus",
}

export const PROGRAM_TYPES = [
  {
    id: 1,
    name: "Online",
  },
  {
    id: 2,
    name: "On Campus",
  },
];

export enum ProgramAccommodationFee {
  ROOM_AND_BOARD = "board",
  HOMESTAY = "homestay",
  INSURANCE = "insurance",
}

export enum HousingType {
  BOARDING = 1,
  HOMESTAY = 2,
  DAY = 3,
}

export const HOUSING_TYPES = [
  {
    id: HousingType.BOARDING,
    name: "Boarding",
  },
  {
    id: HousingType.HOMESTAY,
    name: "Homestay",
  },
  {
    id: HousingType.DAY,
    name: "Day",
  },
];

export const HOUSING_TYPES_MAP = {
  [HousingType.BOARDING]: "Boarding",
  [HousingType.HOMESTAY]: "Homestay",
  [HousingType.DAY]: "Day",
};

export enum DetailType {
  DegreeDetails = 1,
  ProgramDescription = 2,
  CourseDescription = 3,
  AreasOfConcentration = 4,
  Intakes = 5,
  ImportantDates = 6,
  TuitionAndFees = 7,
  OtherFees = 8,
  PaymentPlanOptions = 9,
  Scholarships = 10,
  Grants = 11,
  FinancialAid = 12,
  DepositAndRefundPolicy = 13,
  RequiredDocuments = 14,
  Exams = 15,
  Branches = 16,
  CancellationPolicy = 17,
  OtherComments = 18,
  FAQ = 19,
}

interface DetailConfig {
  type: number;
  name: string;
  isRequired: boolean;
}

export const programDetailsConfig: DetailConfig[] = [
  {
    type: DetailType.DegreeDetails,
    name: "Degree Details",
    isRequired: false,
  },
  {
    type: DetailType.ProgramDescription,
    name: "Program Description",
    isRequired: true,
  },
  {
    type: DetailType.CourseDescription,
    name: "Course Description",
    isRequired: true,
  },
  {
    type: DetailType.AreasOfConcentration,
    name: "Areas of Concentration",
    isRequired: false,
  },
  {
    type: DetailType.Intakes,
    name: "Intakes",
    isRequired: true,
  },
  {
    type: DetailType.ImportantDates,
    name: "Important Dates",
    isRequired: false,
  },
  {
    type: DetailType.TuitionAndFees,
    name: "Tuition and Fees",
    isRequired: true,
  },
  {
    type: DetailType.PaymentPlanOptions,
    name: "Payment Plan Options",
    isRequired: false,
  },
  {
    type: DetailType.Scholarships,
    name: "Scholarships",
    isRequired: false,
  },
  {
    type: DetailType.OtherFees,
    name: "Other Fees",
    isRequired: true,
  },
  {
    type: DetailType.Grants,
    name: "Grants",
    isRequired: false,
  },
  {
    type: DetailType.FinancialAid,
    name: "Financial Aid",
    isRequired: false,
  },
  {
    type: DetailType.RequiredDocuments,
    name: "Required Documents",
    isRequired: true,
  },
  {
    type: DetailType.DepositAndRefundPolicy,
    name: "Deposit and Refund Policy",
    isRequired: true,
  },
  {
    type: DetailType.Exams,
    name: "Exams",
    isRequired: false,
  },
  {
    type: DetailType.Branches,
    name: "Branches",
    isRequired: false,
  },
  {
    type: DetailType.CancellationPolicy,
    name: "Cancellation Policy",
    isRequired: false,
  },
  {
    type: DetailType.OtherComments,
    name: "Other Comments",
    isRequired: false,
  },
  {
    type: DetailType.FAQ,
    name: "FAQ",
    isRequired: false,
  },
];
